function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { PhoneNumberUtil } from 'google-libphonenumber';
import { api } from '@signiapp/helpers';
import { MODULE_BASE_PATH } from "./constants";
var phoneUtil = PhoneNumberUtil.getInstance();
var req = function req(url, options) {
  return api.req(/^http/.test(url) ? url : "".concat(MODULE_BASE_PATH).concat(url), options);
};
export var init = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(stack, signers) {
    var options;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          options = {
            stack: stack,
            signers: signers
          };
          return _context.abrupt("return", req('/sign-orders', {
            method: 'POST',
            body: JSON.stringify(options),
            headers: {
              'Content-Type': 'application/json'
            }
          }));
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function init(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var getSignMechanisms = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(stack) {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.abrupt("return", req("/metadata/sign-mechanisms?stack=".concat(stack)));
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getSignMechanisms(_x3) {
    return _ref2.apply(this, arguments);
  };
}();
export var getIdps = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(stack, signMechanism) {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.abrupt("return", req("/metadata/idps?stack=".concat(stack, "&signMechanism=").concat(signMechanism)));
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function getIdps(_x4, _x5) {
    return _ref3.apply(this, arguments);
  };
}();
export var getById = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(orderId) {
    var transform;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          transform = {
            fromApi: function fromApi(res) {
              var transformed = _objectSpread(_objectSpread({}, res), {}, {
                metaData: _objectSpread(_objectSpread({}, res.metaData), {}, {
                  lastUpdated: res.metaData.lastUpdated || res.metaData.created
                }),
                signers: (res.signers || []).map(function (s) {
                  return _objectSpread(_objectSpread({}, s), {}, {
                    mobileNumber: s.mobile ? "".concat(s.mobile.prefix).concat(s.mobile.number) : null
                  });
                })
              });
              return transformed;
            }
          };
          return _context4.abrupt("return", req("/sign-orders/".concat(orderId), {
            cache: 'no-cache'
          }).then(transform.fromApi));
        case 2:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function getById(_x6) {
    return _ref4.apply(this, arguments);
  };
}();
export var head = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(orderId) {
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          return _context5.abrupt("return", req("/sign-orders/".concat(orderId), {
            method: 'HEAD',
            cache: 'no-cache'
          }).then(function (result) {
            return result.headers;
          }));
        case 1:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function head(_x7) {
    return _ref5.apply(this, arguments);
  };
}();
export var getAll = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
    var transform;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          transform = {
            fromApi: function fromApi(res) {
              var transformed = {
                nextCursor: res.nextCursor || null,
                previousCursor: res.previousCursor || null,
                limit: res.limit,
                data: res.data.map(function (order) {
                  return _objectSpread(_objectSpread({
                    id: order.id
                  }, order), {}, {
                    signers: ((order === null || order === void 0 ? void 0 : order.signers) || []).map(function (s) {
                      return _objectSpread(_objectSpread({}, s), {}, {
                        mobileNumber: s.mobile ? "".concat(s.mobile.prefix).concat(s.mobile.number) : null
                      });
                    })
                  });
                })
              };
              return transformed;
            }
          };
          return _context7.abrupt("return", req('/sign-orders?includeDeleted=true&limit=100&offset=0').then(transform.fromApi).then(function (res) {
            var getRemainingPages = /*#__PURE__*/function () {
              var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(firstPage) {
                var allPages, prevPage, currPage;
                return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                  while (1) switch (_context6.prev = _context6.next) {
                    case 0:
                      allPages = {
                        data: _toConsumableArray(firstPage.data)
                      };
                      prevPage = _objectSpread({}, firstPage);
                    case 2:
                      _context6.next = 4;
                      return req(prevPage.nextCursor);
                    case 4:
                      currPage = _context6.sent;
                      allPages.data = [].concat(_toConsumableArray(allPages.data), _toConsumableArray(transform.fromApi(currPage).data));
                      prevPage = _objectSpread({}, currPage);
                    case 7:
                      if (currPage.nextCursor) {
                        _context6.next = 2;
                        break;
                      }
                    case 8:
                      return _context6.abrupt("return", allPages);
                    case 9:
                    case "end":
                      return _context6.stop();
                  }
                }, _callee6);
              }));
              return function getRemainingPages(_x8) {
                return _ref7.apply(this, arguments);
              };
            }();
            if (res.nextCursor) {
              return getRemainingPages(res);
            }
            return res;
          }));
        case 2:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return function getAll() {
    return _ref6.apply(this, arguments);
  };
}();
export var getPage = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(offset, filter, orderBy, authorId, forceUpdate, createdBefore, signedBefore) {
    var transform, url, _iterator, _step, item, result;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          transform = function transform(res) {
            return {
              next: res.nextCursor || null,
              prev: res.previousCursor || null,
              limit: res.limit,
              total: res.total,
              data: res.data.map(function (order) {
                return _objectSpread(_objectSpread({
                  id: order.id
                }, order), {}, {
                  signers: ((order === null || order === void 0 ? void 0 : order.signers) || []).map(function (s) {
                    return _objectSpread(_objectSpread({}, s), {}, {
                      mobileNumber: s.mobile ? "".concat(s.mobile.prefix).concat(s.mobile.number) : null
                    });
                  })
                });
              })
            };
          };
          url = '/sign-orders?includeDeleted=false&limit=20';
          if (offset) {
            url += "&offset=".concat(offset);
          }
          if ((filter === null || filter === void 0 ? void 0 : filter.id) === 'myorders' && authorId) {
            url += "&authorId=".concat(authorId);
          } else if (filter !== null && filter !== void 0 && filter.status && (filter === null || filter === void 0 ? void 0 : filter.status.length) > 0) {
            _iterator = _createForOfIteratorHelper(filter.status);
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                item = _step.value;
                url += "&status=".concat(item);
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }
          if (filter !== null && filter !== void 0 && filter.searchTerm) {
            url += "&wildcard=".concat(filter === null || filter === void 0 ? void 0 : filter.searchTerm);
          }
          if (orderBy) {
            url += "&orderBy=".concat(orderBy.field);
            url += "&orderByDesc=".concat(orderBy.desc);
          }
          if (forceUpdate) {
            url += "&time=".concat(Date.now());
          }
          if (createdBefore) {
            url += "&createdBefore=".concat(createdBefore);
          }
          if (signedBefore) {
            url += "&signedBefore=".concat(signedBefore);
          }
          _context8.next = 11;
          return req(url);
        case 11:
          result = _context8.sent;
          return _context8.abrupt("return", transform(result));
        case 13:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return function getPage(_x9, _x10, _x11, _x12, _x13, _x14, _x15) {
    return _ref8.apply(this, arguments);
  };
}();
export var save = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(order) {
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          return _context9.abrupt("return", req("/sign-orders/".concat(order.id), {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(order)
          }));
        case 1:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return function save(_x16) {
    return _ref9.apply(this, arguments);
  };
}();
export var saveSigner = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(orderId, signer) {
    var mobileNumber, mobile, data, isNew;
    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          try {
            mobileNumber = phoneUtil.parseAndKeepRawInput(signer.mobileNumber || '', 'NO');
            mobileIsValid = phoneUtil.isValidNumber(mobileNumber);
          } catch (err) {
            // TODO: Handle?
          }
          mobile = mobileNumber ? {
            prefix: "+".concat(mobileNumber.getCountryCode()),
            number: mobileNumber.getNationalNumber()
          } : null;
          data = _objectSpread(_objectSpread({}, signer), {}, {
            email: signer.email || null,
            firstName: signer.firstName || null,
            lastName: signer.lastName || null,
            companyName: signer.companyName || null,
            companyRole: signer.companyRole || null,
            mobile: mobile
          });
          isNew = typeof signer.id === 'undefined';
          return _context10.abrupt("return", req("/sign-orders/".concat(orderId, "/signers").concat(isNew ? '' : "/".concat(signer.id)), {
            method: isNew ? 'POST' : 'PUT',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(function (data) {
            return _objectSpread(_objectSpread({}, data), {}, {
              mobileNumber: data.mobile ? "".concat(data.mobile.prefix).concat(data.mobile.number) : null
            });
          })["catch"](function (err) {
            throw err;
          }));
        case 5:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return function saveSigner(_x17, _x18) {
    return _ref10.apply(this, arguments);
  };
}();
export var send = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(order) {
    return _regeneratorRuntime().wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          return _context11.abrupt("return", req("/sign-orders/".concat(order.id, "/send"), {
            method: 'PUT'
          }));
        case 1:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return function send(_x19) {
    return _ref11.apply(this, arguments);
  };
}();
export var destroy = function destroy(orderId) {
  return req("/sign-orders/".concat(orderId), {
    method: 'DELETE'
  });
};
export var changeDeadline = function changeDeadline(orderId, newDate) {
  return req("/sign-orders/".concat(orderId, "/changeDeadline/").concat(newDate), {
    method: 'POST'
  });
};
export var restore = function restore(orderId) {
  return req("/sign-orders/".concat(orderId, "/restore"), {
    method: 'POST'
  });
};
export var cancel = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(orderId, reason) {
    var maxRetries, retriesCounter, checkIfCanceled, queryString;
    return _regeneratorRuntime().wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          maxRetries = 10;
          retriesCounter = 0;
          checkIfCanceled = /*#__PURE__*/function () {
            var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
              var order;
              return _regeneratorRuntime().wrap(function _callee12$(_context12) {
                while (1) switch (_context12.prev = _context12.next) {
                  case 0:
                    _context12.next = 2;
                    return getById(orderId);
                  case 2:
                    order = _context12.sent;
                    return _context12.abrupt("return", order.status === 'canceled');
                  case 4:
                  case "end":
                    return _context12.stop();
                }
              }, _callee12);
            }));
            return function checkIfCanceled() {
              return _ref13.apply(this, arguments);
            };
          }();
          queryString = ["reason=".concat(encodeURIComponent(reason)), "id=".concat(encodeURIComponent(orderId))].join('&');
          return _context14.abrupt("return", req("/sign-orders/".concat(orderId, "/cancel?").concat(queryString), {
            method: 'POST'
          }).then(function () {
            var isCanceled = false;
            return new Promise( /*#__PURE__*/function () {
              var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(resolve, reject) {
                return _regeneratorRuntime().wrap(function _callee13$(_context13) {
                  while (1) switch (_context13.prev = _context13.next) {
                    case 0:
                      if (!(isCanceled === false)) {
                        _context13.next = 11;
                        break;
                      }
                      if (retriesCounter > maxRetries) {
                        reject('Reached max retires checking for canceled order');
                      }
                      retriesCounter++;
                      _context13.next = 5;
                      return checkIfCanceled();
                    case 5:
                      isCanceled = _context13.sent;
                      if (!(isCanceled === false)) {
                        _context13.next = 9;
                        break;
                      }
                      _context13.next = 9;
                      return new Promise(function (r) {
                        return setTimeout(r, 2000);
                      });
                    case 9:
                      _context13.next = 0;
                      break;
                    case 11:
                      resolve();
                    case 12:
                    case "end":
                      return _context13.stop();
                  }
                }, _callee13);
              }));
              return function (_x22, _x23) {
                return _ref14.apply(this, arguments);
              };
            }());
          }));
        case 5:
        case "end":
          return _context14.stop();
      }
    }, _callee14);
  }));
  return function cancel(_x20, _x21) {
    return _ref12.apply(this, arguments);
  };
}();
export var removeFile = function removeFile(orderId, fileId) {
  return req("/sign-orders/".concat(orderId, "/files/").concat(fileId), {
    method: 'DELETE'
  });
};
export var addFiles = function addFiles(orderId, files) {
  return req("/sign-orders/".concat(orderId, "/files"), {
    method: 'POST',
    body: files
  });
};
export var repairFile = function repairFile(orderId, fileId) {
  return req("/sign-orders/".concat(orderId, "/files/").concat(fileId, "/repair"), {
    method: 'PATCH'
  });
};
export var editFile = function editFile(orderId, fileId, parameter, value) {
  var body = _defineProperty({}, parameter, value);
  body = JSON.stringify(body);
  return req( // TODO : validate with Razvan
  "/sign-orders/".concat(orderId, "/files/").concat(fileId), {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    body: body
  });
};
export var removeSigner = function removeSigner(orderId, signerId) {
  return req("/sign-orders/".concat(orderId, "/signers/").concat(signerId), {
    method: 'DELETE'
  });
};
export var sendReminder = function sendReminder(orderId, signerId) {
  return req("/sign-orders/".concat(orderId, "/signers/").concat(signerId, "/reminder"), {
    method: 'POST'
  });
};
export default {
  cancel: cancel,
  init: init,
  send: send,
  getById: getById,
  getAll: getAll,
  save: save,
  head: head,
  destroy: destroy,
  restore: restore,
  removeFile: removeFile,
  addFiles: addFiles,
  repairFile: repairFile,
  editFile: editFile,
  saveSigner: saveSigner,
  removeSigner: removeSigner,
  changeDeadline: changeDeadline,
  getIdps: getIdps,
  getSignMechanisms: getSignMechanisms,
  sendReminder: sendReminder,
  getPage: getPage
};